import { useState } from "react";
import {
  Box,
  Container,
  Stack,
  IconButton,
  Drawer
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Link, useLocation } from "react-router-dom";
import logo from "../static/logo.webp";

function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Schedule", path: "/calendario-de-partidos" },
    { label: "Gallery", path: "/galeria", cta: true }
  ];

  const isActive = path => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderBottom: "1px solid #eee"
      }}
    >
      <Container
        sx={{
          height: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <Box
          component={Link}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="SAAC Basketball Quito 2026"
            sx={{ height: { xs: 56, md: 70 } }}
          />
        </Box>

        <Stack
          direction="row"
          spacing={3}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center"
          }}
        >
          {navItems.map(item => {
            const active = isActive(item.path);

            if (item.cta) {
              return (
                <Box
                  key={item.path}
                  component={Link}
                  to={item.path}
                  sx={{
                    px: 3,
                    py: 1.2,
                    borderRadius: "999px",
                    fontWeight: 700,
                    fontSize: ".95rem",
                    textDecoration: "none",
                    backgroundColor: active
                      ? "primary.dark"
                      : "primary.main",
                    color: "#fff",
                    transition: ".25s",
                    boxShadow: active
                      ? "0 0 0 2px rgba(8,112,162,.35)"
                      : "0 8px 18px rgba(8,112,162,.25)",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                      transform: "scale(1.06)"
                    }
                  }}
                >
                  {item.label}
                </Box>
              );
            }

            return (
              <Box
                key={item.path}
                component={Link}
                to={item.path}
                sx={{
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: ".95rem",
                  color: active ? "primary.main" : "#333",
                  position: "relative",
                  transition: ".2s",
                  "&:hover": {
                    color: "primary.main"
                  }
                }}
              >
                {item.label}
              </Box>
            );
          })}
        </Stack>

        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "primary.main"
          }}
        >
          <MenuRoundedIcon />
        </IconButton>
      </Container>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            width: 260,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            px: 3,
            pt: 2
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={() => setOpen(false)}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          <Stack spacing={2.2} sx={{ mt: 2 }}>
            {navItems.map(item => {
              const active = isActive(item.path);

              if (item.cta) {
                return (
                  <Box
                    key={item.path}
                    component={Link}
                    to={item.path}
                    onClick={() => setOpen(false)}
                    sx={{
                      textDecoration: "none",
                      fontWeight: 700,
                      fontSize: "1.05rem",
                      textAlign: "center",
                      py: 1.3,
                      borderRadius: "999px",
                      backgroundColor: active
                        ? "primary.dark"
                        : "primary.main",
                      color: "#fff",
                      boxShadow: active
                        ? "0 0 0 2px rgba(8,112,162,.35)"
                        : "0 6px 16px rgba(8,112,162,.25)"
                    }}
                  >
                    {item.label}
                  </Box>
                );
              }

              return (
                <Box
                  key={item.path}
                  component={Link}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  sx={{
                    textDecoration: "none",
                    fontWeight: 700,
                    fontSize: "1.05rem",
                    color: active ? "primary.main" : "#333"
                  }}
                >
                  {item.label}
                </Box>
              );
            })}
          </Stack>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Navbar;